import { isTestCafeEnabled } from '@/helpers/isTestCafeEnabled'

const apiPrefix = isTestCafeEnabled()
  ? import.meta.env.VITE_APP_API_BASE_TESTCAFE_URL
  : import.meta.env.VITE_APP_API_URL

const resource = {
  publicProvinces: 'public/resource/provinces',
  publicSchoolsPerProvince: 'public/resource/location/school-per-province/:provinceId',
  consent: 'public/resource/consent-form/:consentFormName',
  publicResourceDocument: 'public/resource/document/:documentType',
  resourceDocument: 'resource/document/:documentType/edition/:editionName',
  provinces: 'resource/provinces/list',
  schoolsPerProvince: 'resource/schools-per-province/:provinceId',
  traditionalPaymentStatus: 'resource/traditional-payment-status',
  excludeChildReasons: 'resource/child-edition-exclusion-reason',
  resourceSuccessCard: 'resource/success-card/edition/:editionName',
  resourceDonorContact: 'resource/contact-with-gift-giver/edition/:editionName',
  paymentListFilterData: 'resource/payment-list-filter-data',
  childrenListFilterData: 'resource/child-edition-list-filter-data',
  schoolsWithProvinceFilterData: 'resource/schools-with-province/list',
  flowActionsChildEdition: 'resource/flow-actions/child-edition/:childEditionId',
  flowActionsPayment: 'resource/flow-actions/payment/:paymentId'
}

export default {
  apiPrefix: `${apiPrefix}v1/`,
  endpoints: {
    auth: 'auth/:action',
    publicChildEdition: 'public/child-edition',
    publicChildEditionCreateForm: 'public/edition/child-edition-create-form',
    ...resource,
    filterChildren: 'child-edition/:filter',
    childEdition: 'child-edition/:childEditionId',
    childEditionAssigned: 'child-edition/assigned/:childEditionId',
    childEditionForCoordinator: 'child-edition/:childEditionId/coordinator',
    childEditionPreviousEdition: 'child-edition/:childEditionId/previous-edition',
    childEditionPreviousEditionAssigned: 'child-edition/assigned/:childEditionId/previous-edition',
    otherChildEditionIds: 'child-edition/:childEditionId/get-ids-for-all-editions',
    otherChildEditionIdsAssigned: 'child-edition/assigned/:childEditionId/get-ids-for-all-editions',
    changeSchool: 'child-edition/:childEditionId/change-school',
    publish: 'child-edition/:childEditionId/publish',
    assignVolunteer: 'child-edition/:childEditionId/volunteer-assign',
    detachVolunteer: 'child-edition/:childEditionId/volunteer-detach',
    volunteerCooperation: 'child-edition/:childEditionId/volunteer-cooperation',
    revokePublication: 'child-edition/:childEditionId/revoke-publication',
    updatePersonalData: 'child-edition/:childEditionId/update-personal-data',
    updateGuardianData: 'child-edition/:childEditionId/update-guardian ',
    paymentsList: 'child-edition/:childEditionId/payments-list',
    excludeChild: 'child-edition/:childEditionId/exclude',
    includeAgainChild: 'child-edition/:childEditionId/include-again',
    getVolunteers: 'volunteer/list/:wioStructLocationId',
    document: 'document/child-edition/:childEditionId/:documentType',
    documentForCoordinator: 'document/child-edition/:childEditionId/:documentType/coordinator',
    documentUpdate: 'document/child-edition/:childEditionId/:documentType/update',
    documentAdditionalView: 'document/child-edition/:childEditionId/:documentType/additional-view',
    documentAssigned: 'document/assigned/child-edition/:childEditionId/:documentType',
    acceptDocument: 'document/child-edition/:childEditionId/:documentType/accept',
    privilegedUpdate: 'document/child-edition/:childEditionId/:documentType/privileged-update',
    drawingBySizeAssigned:
      'dream-drawing-image/child-edition/:childEditionId/assigned/imageType/:size',
    drawingBySize: 'dream-drawing-image/child-edition/:childEditionId/imageType/:size',
    filterPayments: 'payment/filter',
    payment: 'payment/:paymentId',
    paymentUpdate: 'payment/:paymentId/update',
    cancelPayment: 'payment/:paymentId/cancel',
    paymentCreateTraditional: 'payment/:paymentId/create-traditional',
    paymentPersonalData: 'payment/:paymentId/personal-data',
    updatePaymentNote: 'payment/:paymentId/note',
    resendInstallmentNotification: 'payment/:paymentId/resend-installment-notification',
    switchChildEdition: 'payment/:paymentId/switch-child-edition/:childEditionId',
    successCard: 'success-card/child-edition/:childEditionId',
    successCardAssigned: 'success-card/assigned/child-edition/:childEditionId',
    updateSuccessCard: 'success-card/:successCardId/child-edition/:childEditionId/update',
    privilegedUpdateSuccessCard:
      'success-card/:successCardId/child-edition/:childEditionId/privileged-update',
    sendToGiftGiver: 'success-card/:successCardId/child-edition/:childEditionId/send-to-gift-giver',
    getSuccessCard: 'success-card/:successCardId/child-edition/:childEditionId',
    getSuccessCardAssigned: 'success-card/assigned/:successCardId/child-edition/:childEditionId',
    correctionSuccessCard: 'success-card/:successCardId/child-edition/:childEditionId/correction',
    correctionSuccessCardAssigned:
      'success-card/assigned/:successCardId/child-edition/:childEditionId/correction',
    sendBackSuccessCard: 'success-card/:successCardId/child-edition/:childEditionId/send-back',
    correctionSendBackSuccessCard:
      'success-card/:successCardId/child-edition/:childEditionId/correction-send-back',
    correctionSendBackSuccessCardAssigned:
      'success-card/assigned/:successCardId/child-edition/:childEditionId/correction-send-back',
    donorContact: 'contact-with-gift-giver/child-edition/:childEditionId',
    donorContactAssigned: 'contact-with-gift-giver/assigned/child-edition/:childEditionId',
    getDonorContact: 'contact-with-gift-giver/:donorContactId/child-edition/:childEditionId',
    getDonorContactAssigned:
      'contact-with-gift-giver/assigned/:donorContactId/child-edition/:childEditionId',
    sendBack: 'document/child-edition/:childEditionId/:documentType/send-back',
    sendToAccept: 'document/child-edition/:childEditionId/:documentType/send-to-accept',
    sendToAcceptAssigned:
      'document/assigned/child-edition/:childEditionId/:documentType/send-to-accept',
    correction: 'document/child-edition/:childEditionId/:documentType/correction',
    correctionAssigned: 'document/assigned/child-edition/:childEditionId/:documentType/correction',
    comment: 'document/child-edition/:childEditionId/:documentType/comment',
    commentAssigned: 'document/assigned/child-edition/:childEditionId/:documentType/comment',
    successCardComment: 'success-card/:successCardId/child-edition/:childEditionId/comment',
    successCardCommentAssigned:
      'success-card/assigned/:successCardId/child-edition/:childEditionId/comment',
    pesel: 'child-edition/:childEditionId/pesel',
    peselPreviousEdition: 'child-edition/:childEditionId/pesel/previous-edition',
    recommendationView: 'child-edition/:childEditionId/next-edition-recommendation',
    recommendationViewForCoordinator:
      'child-edition/:childEditionId/next-edition-recommendation/coordinator',
    nextEditionAplicationCheck: 'public/child-edition/next-edition-application/:hash/check',
    nextEditionApplication: 'public/child-edition/next-edition-application/:hash',
    nextEditionApplicationPreview: 'child-edition/:childEditionId/next-edition-application',
    publicCoordinatorQuestionnaire: 'public/child-edition/coordinator-questionnaire/:hash',
    publicCoordinatorQuestionnaireViewData:
      'public/child-edition/coordinator-questionnaire-view-data/:hash'
  },
  get(endpointLabel, params) {
    if (this.endpoints[endpointLabel] === undefined) {
      throw new Error('undefined api path')
    }

    let url = this.endpoints[endpointLabel]

    if (typeof params === 'object') {
      Object.keys(params).forEach((param) => {
        url = url.replace(`:${param}`, params[param])
      })
    } else if (url.indexOf('/:') > 0) {
      url = url.substring(0, url.indexOf('/:'))
    }

    if (url.indexOf('_') !== -1) {
      url = url.replaceAll('_', '-')
    }

    return this.apiPrefix.concat(url)
  }
}
